module.exports = __webpack_public_path__ + "media/door-bell.49735e7b.wav";